import React from 'react';
import styled from 'styled-components';
import { Body1, H1 } from '@ui';
import { SplashSectionWrapper } from './styles';
import { selectLightTheme } from '@utils/themes';
import { convertHexToRGBA } from '@utils/usefulFuncs';

const Wrapper = styled.div``;
const HeadingWrapper = styled.div`
  padding-bottom: 36px;
  text-align: left;
  width: 100%;

  h1 {
    font-size: 48px;
    line-height: 64px;
    letter-spacing: -3px;
  }

  @media (max-width: 710px) {
    h1 {
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -1px;
    }
  }
`;
const DescriptionWrapper = styled.div`
  padding: 24px 0 0 0;
  max-width: 800px;
`;
const LogoWrapper = styled.div`
  width: 280px;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;

    fill: ${({ theme }) => convertHexToRGBA(selectLightTheme(theme).text, 0.4)} !important;
  }

  &.box {
    text-align: center;

    svg {
      width: 100px;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &.aws img {
    width: 140px;
    opacity: 0.5;
  }

  &.snowflake img {
    // width: 280px;
  }

  &.sharepoint img {
    // width: 240px;
  }

  &.onedrive img {
    // width: 240px;
  }
`;
const LogoGrid = styled.div`
  padding: 78px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  gap: 64px;
  justify-content: center;
  align-items: center;

  @media (max-width: 1060px) {
    gap: 16px;

    ${LogoWrapper} {
      width: 340px;
      text-align: center;

      &.aws img {
        width: 120px;
        opacity: 0.5;
      }

      &.box svg {
        width: 80px;
      }

      &.snowflake img {
        width: 220px;
      }

      &.sharepoint img {
        width: 220px;
      }

      &.onedrive img {
        width: 220px;
      }
    }
  }

  @media (max-width: 765px) {
    ${LogoWrapper} {
      &.aws img {
        width: 110px;
        opacity: 0.5;
        margin-top: 16px;
      }
    }
  }
`;

const BoxLogo = () => (
  <svg class="logo-box" id="Layer_1" viewBox="0 0 40 21.6">
    <style type="text/css"></style>
    <path
      class="box-logo-svg"
      d="M39.7 19.2c.5.7.4 1.6-.2 2.1-.7.5-1.7.4-2.2-.2l-3.5-4.5-3.4 4.4c-.5.7-1.5.7-2.2.2-.7-.5-.8-1.4-.3-2.1l4-5.2-4-5.2c-.5-.7-.3-1.7.3-2.2.7-.5 1.7-.3 2.2.3l3.4 4.5L37.3 7c.5-.7 1.4-.8 2.2-.3.7.5.7 1.5.2 2.2L35.8 14l3.9 5.2zm-18.2-.6c-2.6 0-4.7-2-4.7-4.6 0-2.5 2.1-4.6 4.7-4.6s4.7 2.1 4.7 4.6c-.1 2.6-2.2 4.6-4.7 4.6zm-13.8 0c-2.6 0-4.7-2-4.7-4.6 0-2.5 2.1-4.6 4.7-4.6s4.7 2.1 4.7 4.6c0 2.6-2.1 4.6-4.7 4.6zM21.5 6.4c-2.9 0-5.5 1.6-6.8 4-1.3-2.4-3.9-4-6.9-4-1.8 0-3.4.6-4.7 1.5V1.5C3.1.7 2.4 0 1.6 0 .7 0 0 .7 0 1.5v12.6c.1 4.2 3.5 7.5 7.7 7.5 3 0 5.6-1.7 6.9-4.1 1.3 2.4 3.9 4.1 6.8 4.1 4.3 0 7.8-3.4 7.8-7.7.1-4.1-3.4-7.5-7.7-7.5z"
    ></path>
  </svg>
);

export const ConnectToAdapters = () => {
  return (
    <SplashSectionWrapper>
      <HeadingWrapper>
        <H1>Securely connect to your internal data</H1>
        <DescriptionWrapper>
          <Body1>
            Seamlessly connect your data to create accurate human level workflows and analyses. Ingest documents,
            research, models, deal rooms, etc. and securely harness your existing data infrastructure. Unlock powerful
            insights, and vastly accelerate and scale workflows to drive smarter decisions.
          </Body1>
        </DescriptionWrapper>
      </HeadingWrapper>
      <LogoGrid>
        <LogoWrapper className="snowflake">
          <img src="/images/logos/snowflake-g.png" alt="Snowflake" />
        </LogoWrapper>
        <LogoWrapper className="sharepoint">
          <img src="/images/logos/sharepoint-g.png" alt="SharePoint" />
        </LogoWrapper>
        <LogoWrapper className="onedrive">
          <img src="/images/logos/onedrive-g.png" alt="OneDrive" />
        </LogoWrapper>
        <LogoWrapper className="box">
          <BoxLogo />
        </LogoWrapper>
        <LogoWrapper className="aws">
          <img src="/images/logos/aws-g.png" alt="AWS" />
        </LogoWrapper>
      </LogoGrid>
    </SplashSectionWrapper>
  );
};
